import { PrimaryButton, SecondaryButton } from '@/components/Button';
import { Dialog } from '@/components/Dialog';
import { Input } from '@/components/ui/input';
import { useState } from 'react';
import { toast } from 'sonner';
import BellRingIcon from '@/assets/icons/BellRing.svg';
import { setMonthlyLimitAlert } from '@/service/overview';
import TrashIcon from '@/assets/icons/Trash.svg';

export const useOverview = () => {
  const setMonthlyLimitAlertModal = async () => {
    const res = await Dialog.info({
      contentJSX: ({ onClose, resolve }) => {
        const [val, setVal] = useState<string | undefined>(undefined);
        return (
          <div className="flex flex-col gap-8">
            <div className="w-fit rounded-full p-2 bg-[#FF5B271A]">
              <div className="w-fit rounded-full p-3 bg-jen-interactive-accent">
                <BellRingIcon />
              </div>
            </div>

            <div>
              <h1 className="text-[20px]">Spend Limit Alert</h1>
              <div className="text-[#747479] mt-2 leading-[20px] tracking-[-0.32px]">
                Create an alert for how much you spend in a given month. We’ll send you an email when you’re at 70% and 100% of your limit
                to remind you.
              </div>
            </div>
            <div>
              <div>Spend Limit</div>
              <div className="relative">
                <Input
                  prefix="$"
                  value={val}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setVal(event.target.value);
                  }}
                  className="mt-2 pl-7"
                  placeholder="00,000"
                />
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2 ">$</div>
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer hover:opacity-90"
                  onClick={async () => {
                    try {
                      await setMonthlyLimitAlert({ monthly_limit_alert: 0 });
                      onClose();
                      resolve();
                    } catch (error) {
                      toast.error('network error,please try again');
                    }
                  }}
                >
                  <TrashIcon fillColor="#bc3229" />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 justify-between gap-2">
              <SecondaryButton onClick={() => onClose()}>Cancel</SecondaryButton>
              <PrimaryButton
                onClick={async () => {
                  if (val?.trim()) {
                    try {
                      await setMonthlyLimitAlert({ monthly_limit_alert: Number(val) });
                      onClose();
                      resolve();
                    } catch (error) {
                      toast.error('network error,please try again');
                    }
                  }
                }}
              >
                Save
              </PrimaryButton>
            </div>
          </div>
        );
      },
    });
    return res;
  };

  return {
    setMonthlyLimitAlertModal,
  };
};
